import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";
export const incidenciaService = {
  getIncidencias,
  getIncidenciaById,
  getIncidenciaChats,
  patchIncidencia,
  postMensaje,
  deleteChatIncidencia,
  putChatIncidencia,
  getAdjunto,
  multipleAsignarIncidencia,
  getIncidenciasAsExcel,
  postMensajesVarios,
  getPayload,
};
function getIncidenciasAsExcel(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/excel?limit=2000`;

  urlPath += getFiltersIncidencias(filters);

  return axios.get(urlPath, {
    responseType: "blob",
  });
}

function getFiltersIncidencias(filters) {
  let urlPath = "";
  if (filters && filters.fecha) {
    urlPath += `&fecha_inicio=${filters.fecha[0]}`;
    urlPath += `&fecha_fin=${filters.fecha[1]}`;
  }
  if (filters && filters.idCliente) {
    urlPath += `&idCliente=${filters.idCliente}`;
  }
  if (filters && filters.localizador) {
    urlPath += `&localizador=${filters.localizador}`;
  }
  if (filters && filters.numero) {
    urlPath += `&numero=${filters.numero}`;
  }
  if (filters && filters.estadoLeido && filters.estadoLeido.length > 0) {
    urlPath += `&estadoLeido=${filters.estadoLeido}`;
  }
  if (filters && filters.estados && filters.estados.length > 0) {
    urlPath += `&estados=${filters.estados.join()}`;
  }
  if (filters && filters.idFranquicia) {
    urlPath += `&franquicia=${filters.idFranquicia}`;
  }
  if (filters && filters.tipo) {
    urlPath += `&tipo=${filters.tipo}`;
  }
  if (filters && filters.ocurrencia !== "") {
    urlPath += `&ocurrencia=${filters.ocurrencia}`;
  }
  if (filters && filters.descripcion) {
    urlPath += `&descripcion=${filters.descripcion}`;
  }
  if (filters && filters.order) {
    urlPath += `&order=${filters.order}`;
  }
  if (filters && filters.sort) {
    urlPath += `&sort=${filters.sort}`;
  }
  if (filters && typeof filters.reclamacion === "boolean") {
    urlPath += `&reclamacion=${filters.reclamacion}`;
  }
  return urlPath;
}

function getIncidencias(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencias`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=10";
  }
  urlPath += getFiltersIncidencias(filters);
  return axios.get(urlPath);
}

function getIncidenciaById(idIncidencia) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}`;
  return axios.get(urlPath);
}

function getIncidenciaChats(idIncidencia, pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}/chat`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  if (filters && filters.sort) {
    urlPath += `&sort=${filters.sort.sort}&order=${filters.sort.order}`;
  }
  return axios.get(urlPath);
}

function patchIncidencia(idIncidencia, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}`;
  return axios.put(urlPath, body);
}

function multipleAsignarIncidencia(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencias/control`;
  return axios.put(urlPath, body);
}

function postMensaje(idIncidencia, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}/chat`;
  return axios.post(urlPath, body);
}

function postMensajesVarios(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/chat`;
  return axios.post(urlPath, body);
}

function deleteChatIncidencia(idIncidencia, idChat) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}/chat/${idChat}`;
  return axios.delete(urlPath);
}

function putChatIncidencia(idIncidencia, idChat, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}/chat/${idChat}`;
  return axios.put(urlPath, body);
}

function getAdjunto(idIncidencia, idChat) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}/chat/${idChat}/adjunto`;
  return axios.get(urlPath, {
    responseType: "blob",
  });
}

function getPayload(idIncidencia) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/incidencia/${idIncidencia}/payload`;
  return axios
    .get(urlPath, { responseType: "blob" })
    .then((response) => {
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition;
      return Promise.resolve({ blob: response.data, fileName: fileName });
    })
    .catch(async (error) => {
      const data = await error.text();
      throw JSON.parse(data);
    });
}
